module.exports = __webpack_public_path__ + "static/media/collapse.081c689b.svg";